export { default } from "./CustomerDetails";
